import Fast from "../../../src/assets/fast.svg";
import FocusLock from "../../../src/assets/focus-lock.svg";
import LiveFull from "../../../src/assets/live-full.svg";

export default function FeaturesBar() {
  return (
    <div className="flex flex-wrap md:flex-nowrap justify-center items-center gap-3 md:gap-8 bg-[#43424259]  font-light px-[10px] md:px-[16px] py-[6px] rounded-2xl shadow-sm">
      <div className="flex items-center gap-1">
        <img src={LiveFull} alt="LiveFull" className="w-5 h-5" />
        <span className="text-sm">Accessible</span>
      </div>
      <div className="flex items-center gap-1">
        <img src={FocusLock} alt="FocusLock" className="w-5 h-5" />
        <span className="text-sm">Reliable</span>
      </div>
      <div className="flex items-center gap-1">
        <img src={Fast} alt="Fast" className="w-5 h-5" />
        <span className="text-sm ">Fast</span>
      </div>
    </div>
  );
}
